import React from 'react';
import styles from './SportCard.module.scss';

/* ───────────────────────────────── component ── */
const SportCardInner = React.forwardRef(({ sport, onSelect }, ref) => (
  <div className={styles.sportSingle}>
    <button
      ref={ref}
      tabIndex={0}
      aria-label={`Filter by ${sport.alias}`}
      className={styles.sportItem}
      onClick={onSelect}
    >
      <img src={sport.logo} alt={sport.alias} className={styles.sportIcon} />
    </button>
  </div>
));
SportCardInner.displayName = 'SportCard';

/* ───────────────────────────── comparison ──
   Re-render only when:
   • the sport identity changes      (id)
   • the logo or alias swaps         (visual change)
   • the onSelect handler reference  (edge-case: re-binding)           */
const areEqualSport = (prev, next) =>
  prev.sport.id    === next.sport.id &&
  prev.sport.logo  === next.sport.logo &&
  prev.sport.alias === next.sport.alias &&
  prev.onSelect    === next.onSelect;

/* ───────────────────────────── export ── */
export default React.memo(SportCardInner, areEqualSport);